// extracted by mini-css-extract-plugin
module.exports = {"reset-botton-container":"index__reset-botton-container__3V4cA","btn-reset":"index__btn-reset__SAQT3"};